<template>
    <footer class="footer" v-if="site.metaTitle">
        <div class="footer__column">
            <Subscribe :popup="false"></Subscribe>
        </div>
        <div class="footer__column footer__about">
            <p>Åpenhet.no er en samarbeidsplattform støttet av <a href="https://norad.no/" target="_blank">Norad</a>.</p>
            <p>
                <a href="https://taxjustice.no/" target="_blank">Tax Justice Norge</a><br />
                er initiativtaker og er ansvarlig for nettsiden.
            </p>
            <p>Kontakt: <a href="mailto:info@xn--penhet-hua.no">info@åpenhet.no</a></p>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex';
import Subscribe from '@/components/Subscribe.vue';

export default {
    name: 'Footer',
    components: {
        Subscribe,
    },
    computed: mapState(['site']),
};
</script>

<style lang="scss">
@import '@/styles/global';

.footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    padding: 30px;
    background-color: #a2bfdb;

    @include bp($laptop) {
        flex-direction: row;
        padding: 50px;
    }

    &__column {
        display: flex;
        flex-direction: column;

        &:first-child {
            padding-bottom: 30px;
            border-bottom: 1px solid #3c72bc;

            @include bp($laptop) {
                width: 66%;
                padding-bottom: 0;
                padding-right: 30px;
                border-right: 1px solid #3c72bc;
                border-bottom-width: 0;
            }
        }

        &:last-child {
            align-items: center;
            justify-content: center;
            padding-top: 30px;

            @include bp($laptop) {
                width: 33%;
                padding-top: 0;
                padding-left: 30px;
            }
        }
    }

    &__about {
        display: block;
        color: #fff;
        text-align: center;

        @include bp($laptop) {
            font-size: 17px;
        }

        p {
            margin-bottom: 10px;
            line-height: 1.3;
        }

        a {
            color: #fff;
            display: inline;
            font-weight: 700;
        }
    }
}
</style>
